import {RankedPlacementState} from '@colonist/leaderboard-types'
import {T} from '../../../../common/T'
import styles from './PlacementChange.module.scss'
import rankedStyles from '../UIGameEndRankedScreen.module.scss'
import React from 'react'
import {Button} from '../../../../common/Button'

export function PlacementChange({
    rankedState,
    onContinue,
}: {
    rankedState: RankedPlacementState
    onContinue: VoidFunction
}) {
    const {title, description} = rankedState.getEndGameScreenText()

    return (
        <div className={styles.container}>
            <div className={styles.contentContainer}>
                <div className={styles.content}><T id={title}/></div>
                <div className={styles.content}><T id={description}/></div>
            </div>

            <div className={styles.buttonContainer}>
                <Button
                    className={rankedStyles.continueButton}
                    onClick={onContinue}
                >
                    <T id={{key: 'strings:game.endGame.footer.continue'}}/>
                </Button>
            </div>
        </div>
    )
}
